import PublicAlbumPage from "@/components/audiolab/MainAlbumPage";
import { queryClient } from "@/components/providers";
import {
  albumsControllerAlbumDetail,
  getAlbumsControllerAlbumDetailQueryKey,
} from "@/lib/lutely-api/gen/albums/albums";
import type { DetailAlbumDto } from "@/lib/lutely-api/gen/dtos";
import { ALBUM_ROUTE_DETAIL } from "@/utils/routeUtils";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/albums/$ALBUM_ID")({
  ...ALBUM_ROUTE_DETAIL,
  loader: async ({ params }) => {
    try {
      const album = await queryClient.fetchQuery({
        queryKey: getAlbumsControllerAlbumDetailQueryKey({
          albumId: params.ALBUM_ID,
        }),
        queryFn: () =>
          albumsControllerAlbumDetail({ albumId: params.ALBUM_ID }),
      });
      return { album };
    } catch {
      return { album: null as DetailAlbumDto | null };
    }
  },
  component: PublicAlbumPage,
});
